import React from 'react'
import Text from '../../../../Text'
import DownloadFileIcon from '../../../../icons/DownloadFileIcon'

import styles from './styles.module.css'

function FileDownload({ fileName, fileType, fileDate, downloadUrl, warningText, hideDownloadButton, howToUrl }) {

  const isFilePDF = ( fileName ) => {
    return getFileExtension(fileName) === 'pdf'
  }

  const getFileExtension = ( fileName ) => {
    return fileName.split('.').pop()
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.fileTypeAndPreview}>
        <Text type='h5'>{fileType}</Text>
        { warningText && <Text type="caption-1">{warningText}</Text> }
        <div className={styles.filePreview}>
          <Text type="caption-1">{fileDate + ' / ' + fileName}</Text>
        </div>
        { howToUrl && (
          <a className={styles.howToLink} href={howToUrl} target="_blank" rel="noreferrer">
            <Text type="caption-1">How to use VRS® ONE</Text>
          </a>
        )}
      </div>
      <a className={!hideDownloadButton ? styles.downloadButton : styles.downloadButtonHidden} href={downloadUrl} target={isFilePDF(fileName) ? '_blank' : '_self'} rel="noreferrer">
        <DownloadFileIcon/>
      </a>
    </div>
  )
}

export default FileDownload
